import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetOtherBannerByIdQuery } from "../../../Services/HomeAPI";
import {  useParams } from "react-router-dom";


function AddCategory() {
    const { id } = useParams();
    const [title, setTitle] = useState("");
    const [image, setImage] = useState(null);
    const [pageName, setPageName] = useState("")
    const [errors, setErrors] = useState({});

    const { data: bannerDetail, isLoading: loadingContent, error, refetch: refetchBannerDetail } = useGetOtherBannerByIdQuery(id);


    useEffect(() => {
        refetchBannerDetail();
    },[refetchBannerDetail])

    useEffect(() => {
        console.log(image);
    }, [image])

    useEffect(() => {
        setTitle(bannerDetail?.data?.title);
        setPageName(bannerDetail?.data?.page_name)

    }, [bannerDetail])




    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Banner</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/other-banner-list"><span>Banner</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">View</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Page Name</label>
                                <select value={pageName} className="form-control" onFocus={() => setErrors((prevErrors) => ({ ...prevErrors, pageName: "" }))} onChange={(e) => setPageName(e.target.value)}>
                                    <option value="">Select Page Name</option>
                                    <option value="About Us">About Us</option>
                                    <option value="Contact Us">Contact Us</option>
                                    <option value="Shop">Shop</option>
                                    <option value="Cart">Cart</option>
                                    <option value="Register">Register</option>
                                    <option value="Login">Login</option>
                                </select>
                                {errors.pageName && <p className="text-danger">{errors.pageName}</p>}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Title</label>
                                <input type="text" className="form-control" onFocus={() => setErrors((prevErrors) => ({ ...prevErrors, title: "" }))} placeholder="Enter Title" value={title} onChange={(e) => setTitle(e.target.value)} />
                                {errors.title && <p className="text-danger">{errors.title}</p>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Image</label>
                                <input type="file" className="form-control" onFocus={() => setErrors((prevErrors) => ({ ...prevErrors, image: "" }))} onChange={(e) => setImage(e.target.files[0])} />
                                {errors.image && <p className="text-danger">{errors.image}</p>}
                                <img src={bannerDetail?.data?.banner_image} className="img-fluid mt-4" alt="img"/>
                            </div>
                        </div>
                    </div>
                    
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
